<mat-accordion [ngClass]="cssClasses()">
  @for (faq of faqItems(); track faq.id; let i = $index) {
    <!--(closed)=""-->
    <mat-expansion-panel
      (opened)="openPanelIndex.set(i)"
      (closed)="openPanelIndex() === i ? openPanelIndex.set(undefined) : null"
      [ngClass]="{
        'mat-before-expanded': openPanelIndex() !== null && openPanelIndex()! - 1 === i,
        'mat-after-expanded': openPanelIndex() !== null && openPanelIndex()! + 1 === i,
      }"
      [class.no--border-around]="!hasBorderAround()"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="faq-title">
          <span class="fs-body-xxs">
            <span class="text-secondary">{{ faq.category.department.name }}</span>
            @if (faq.category.name) {
              <span class="text-body-tertiary">&nbsp;- {{ faq.category.name }}</span>
            }
          </span>
          <span class="d-inline-block w-100 fs-body-md lh-sm">{{ faq.question }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (faq.answer) {
        <div
          class="markdown-content"
          fstrDynamicContent
          [innerHTML]="faq.answer | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
        ></div>
      }
    </mat-expansion-panel>
  }
</mat-accordion>
